import type { DibbsContractSearchFilter } from '@/types/dibbs/Dibbs'

export const DEFAULT_DIBBS_FILTER: DibbsContractSearchFilter = {
  is_active: null,
  active_after: null,
  active_before: null,
  published_after: null,
  published_before: null,
  nsn_numbers: [],
  psc_codes: [],
  cage_codes: [],
  part_numbers: [],
  set_aside_codes: [],
}
